import { engageAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { xeroAPIUrls } from '../data';

type Response = {
  isConnected: boolean;
};

export const getXeroInvoiceStatus = withLogger(async (): Promise<Response> => {
  const response = await engageAxiosClient.get<Response>(
    xeroAPIUrls.xeroStatus,
  );

  return response.data;
});
